// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
// MIT license
(function () {
  var lastTime = 0,
    vendors = ['webkit', 'moz'],
    x;
  for (x = 0; x < vendors.length && !window.requestAnimationFrame; x += x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame =
      window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime(),
        timeToCall = Math.max(0, 16 - (currTime - lastTime)),
        id = window.setTimeout(function () { callback(currTime + timeToCall); }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
}());


/**
 * Detect and return the current active responsive breakpoint in Bootstrap
 * @returns {string}
 */
(function ($) {
    window.getResponsiveBreakpoint = function () {
        //xs - 575
        //sm 576 - 767
        //md 768 - 929
        //lg 930 - 

    var envs = ["xs", "sm", "md", "lg"];
    var env = "";

    var $el = $("<div>");
    $el.appendTo($("body"));

    for (var i = envs.length - 1; i >= 0; i--) {
        env = envs[i];
        $el.addClass("d-" + env + "-none");;
        if ($el.is(":hidden")) {
            break; // env detected
        }
    }
    $el.remove();
    return env;
  }
}(jQuery));


// Determine Viewport.
function isElementInViewport(el) {
  //special bonus for those using jQuery
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
  );
}

/**
* Gravity Department - User Agent
* https://github.com/gravitydepartment/user-agent
*
* @author     Brendan Falkowski
* @copyright  2017 Gravity Department. All rights reserved.
*/


// ==============================================
// User Agent
// ==============================================

var userAgent = {
    ua: '',

    init: function () {
        this.set(navigator.userAgent);
    },

    /**
     * @param {string} ua - User agent string.
     */
    set: function (ua) {
        this.ua = ua.toLowerCase();
    },

    // ----------------------------------------------
    // Detect IE

    isIe: function () {
        return /trident/.test(this.ua);
    },

    isIe10: function () {
        return /trident\/6\.0/.test(this.ua);
    },

    isIe10Down: function () {
        return /msie/.test(this.ua);
    },

    isIe11: function () {
        return /trident\/7\.0/.test(this.ua);
    },

    // ----------------------------------------------
    // Detect iOS characteristics

    // iOS
    isIos: function () {
        return /iphone|ipod|ipad/.test(this.ua);
    },

    // Safari
    isSafari: function () {
        return /safari/.test(this.ua);
    },

    // Standalone (iOS full screen mode)
    isIosStandalone: function () {
        return (typeof window.navigator.standalone !== 'undefined') ? window.navigator.standalone : false;
    },

    // ----------------------------------------------
    // Detect iOS mode

    // iOS Safari
    isIosSafari: function () {
        return (this.isIos() && !this.isIosStandalone() && this.isSafari());
    },

    // iOS Full Screen
    isIosFullScreen: function () {
        return (this.isIos() && this.isIosStandalone() && !this.isSafari());
    },

    // iOS UIWebView
    isIosUiWebView: function () {
        return (this.isIos() && !this.isIosStandalone() && !this.isSafari());
    },

    // ----------------------------------------------
    // Detect unsupported operating systems

    // Old IE
    isOldIe: function () {
        return (
            this.isIe10Down()
        ) ? true : false;
    },

    // Old iOS
    isOldIos: function () {
        return (
            /(iphone|ipod|ipad).* os 4_/.test(this.ua) ||
            /(iphone|ipod|ipad).* os 5_/.test(this.ua) ||
            /(iphone|ipod|ipad).* os 6_/.test(this.ua) ||
            /(iphone|ipod|ipad).* os 7_/.test(this.ua) ||
            /(iphone|ipod|ipad).* os 8_/.test(this.ua)
        ) ? true : false;
    },

    // Old Android
    isOldAndroid: function () {
        return (
            /android 2/.test(this.ua) ||
            /android 3/.test(this.ua) ||
            /android 4.0/.test(this.ua) ||
            /android 4.1/.test(this.ua) ||
            /android 4.2/.test(this.ua) ||
            /android 4.3/.test(this.ua)
        ) ? true : false;
    }
};
userAgent.init();
